export function IconSettings({ className, onClick }: { className?: string; onClick?: () => void }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.767.5c1.58 0 3.054.85 3.845 2.22l1.767 3.06c.79 1.369.79 3.071 0 4.44l-1.767 3.06a4.452 4.452 0 0 1-3.845 2.22H6.233c-1.58 0-3.055-.85-3.845-2.22L.62 10.22a4.453 4.453 0 0 1 0-4.44l1.768-3.06A4.452 4.452 0 0 1 6.233.5h3.534Zm2.606 12.066 1.767-3.06a3.023 3.023 0 0 0 0-3.012l-1.767-3.06a3.02 3.02 0 0 0-2.607-1.505H6.232a3.02 3.02 0 0 0-2.607 1.505l-1.768 3.06a3.023 3.023 0 0 0 0 3.012l1.768 3.06a3.02 3.02 0 0 0 2.607 1.505h3.534a3.02 3.02 0 0 0 2.607-1.505ZM4.666 8.001a3.338 3.338 0 0 1 3.333-3.334 3.338 3.338 0 0 1 3.334 3.334 3.338 3.338 0 0 1-3.334 3.334A3.338 3.338 0 0 1 4.666 8Zm1.428 0c0 1.05.855 1.905 1.905 1.905S9.904 9.05 9.904 8 9.05 6.096 8 6.096s-1.905.855-1.905 1.905Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
